import {
  DEFAULT_APPOINTMENT_DURATION,
  normalizeAppointmentDuration,
} from './appointmentDuration.util'

export const APPOINTMENT_UI_CONFIG_CODE = 'designer_visible_ui_option'
export const APPOINTMENT_UI_CONFIG_KEY = 'patient-appointment-booking'
export const APPOINTMENT_UI_CONFIG_URL =
  '/core/config/configCode/' + APPOINTMENT_UI_CONFIG_CODE

export const DEFAULT_APPOINTMENT_UI_CONFIG = {
  defaultDuration: DEFAULT_APPOINTMENT_DURATION,
  appointmentType: false,
  specialtyCode: false,
  calendarServiceId: true,
  calendarLocationId: true,
  generalNote: true,
  operationalNote: true,
  labTestNote: true,
  radiologyTestNote: true,
}

export const parseJsonObject = (value) => {
  if (!value) return {}
  if (typeof value === 'object') return value

  try {
    const parsed = JSON.parse(value)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (error) {
    return {}
  }
}

export const getConfigRecord = (response) => {
  const data = response?.data?.data
  if (Array.isArray(data)) return data[0] || {}
  return data || response?.data || {}
}

export const normalizeAppointmentUiConfig = (value) => {
  const config = {
    ...DEFAULT_APPOINTMENT_UI_CONFIG,
    ...parseJsonObject(value),
  }

  return {
    ...config,
    defaultDuration: normalizeAppointmentDuration(config.defaultDuration),
  }
}

export const getAppointmentUiConfigFromResponse = (response) => {
  const currentConfig = getConfigRecord(response)
  const jsonData = parseJsonObject(currentConfig?.jsonData)

  return normalizeAppointmentUiConfig(jsonData[APPOINTMENT_UI_CONFIG_KEY])
}
